import WithContainerRoute from 'mobile_web/modules/common/hocs/container-route'
import { FC } from 'react'
import { RouteComponentProps } from 'react-router'
import FavouritesComponent from 'mobile_web/modules/favourites/components/Favourites'

const FavouritesRoute: FC<RouteComponentProps> = props => <FavouritesComponent {...props} />

export default WithContainerRoute(FavouritesRoute)
